import { Link } from 'react-router-dom';

import { Banner } from 'types';
import { resolveBannerDestination } from 'utils';

export type BannerSlideProps = {
  banner: Banner;
  className?: string;
  imageClassName: string;
};

export function BannerSlide({ banner, className, imageClassName }: BannerSlideProps) {
  const destination = resolveBannerDestination(banner);

  const image = <img src={banner.image?.original?.url} alt={banner.title} className={imageClassName} />;

  if (destination.kind === 'none') {
    return <div className={className}>{image}</div>;
  }

  if (destination.kind === 'internal') {
    return (
      <Link
        to={destination.to}
        className={className}
        target={destination.newTab ? '_blank' : undefined}
        rel={destination.newTab ? 'noopener noreferrer' : undefined}
      >
        {image}
      </Link>
    );
  }

  return (
    <a
      href={destination.href}
      className={className}
      target={destination.newTab ? '_blank' : undefined}
      rel={destination.newTab ? 'noopener noreferrer' : undefined}
    >
      {image}
    </a>
  );
}
